import { ISearchTypeTermFieldSchema } from '../../repositories/newbuilding-promos/entities/json_query/SearchTypeTermFieldSchema';
import { IJsonQuerySearchType } from '../../types/jsonQuery/searchType';
import { EJsonQueryType } from '../../types/jsonQuery/term';

export function mapSearchType(term?: ISearchTypeTermFieldSchema | null): IJsonQuerySearchType | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Term,
    value: term.value,
  };
}
